/* ============================================
   PartnerGuard — Protects partner routes
   - Solo role='partner' (en el dominio portal)
   - Redirige al dominio admin (erp) si el rol es admin
   - Redirige a selector si falta elegir cuenta; a portal si es cliente
   ============================================ */

import { Navigate, Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { crossDomainTarget } from '@/lib/domain'

export default function PartnerGuard() {
  const { user, isAuthenticated, role, esEquipo, isCliente, needsAccountSelection, mustChangePassword, loading } = useAuth()

  // El correo va en el salto: el token no cruza de dominio (localStorage es por
  // origen), asi que del otro lado hay que volver a entrar — al menos con el
  // correo puesto y directo en la contrasena.
  const domainTarget = !loading && isAuthenticated ? crossDomainTarget(role, user?.email) : null
  useEffect(() => { if (domainTarget) window.location.replace(domainTarget) }, [domainTarget])

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner" />
        <p>Verificando acceso...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (domainTarget) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner" />
        <p>Redirigiendo...</p>
      </div>
    )
  }

  // Identidad autenticada pero sin cuenta activa → elegir cuenta
  if (needsAccountSelection) {
    return <Navigate to="/seleccionar-cuenta" replace />
  }

  // Gente nuestra (admin o ventas) → al ERP, que es su panel
  if (esEquipo) {
    return <Navigate to="/" replace />
  }

  // Cliente users → redirect to portal
  if (isCliente) {
    return <Navigate to="/portal" replace />
  }

  // Force password change on first login
  if (mustChangePassword) {
    return <Navigate to="/cambiar-password" replace />
  }

  return <Outlet />
}
